import { getRequiredValidator } from '@app/core/validations/hook-forms/validators';
import { ButtonAppearance, ButtonSize } from '@app/shared/components/button/button-enums';
import { numberPattern } from '@app/shared/components/grid-controls/grid-text-field/grid-cell-value-patterns';
import GridTextField from '@app/shared/components/grid-controls/grid-text-field/GridTextField';
import { Alignment } from '@app/shared/enums/alignment.enum';
import PlusSvg from '@app/shared/icons/Plus';
import { NetDebtItemDto } from '@app/shared/models/contracts/project-dto';
import { l } from '@locale/setupI18n';
import { FieldArrayWithId } from 'react-hook-form';
import { EquityBridgeFormValues } from './EquityBridgeContent';
import Button from '@app/shared/components/button/Button';
import MinusRoundedSvg from '@app/shared/icons/MinusRounded';

type EquityBridgeCommonNetDebtItemsProps = {
  commonNetDebtItems: {
    item: NetDebtItemDto;
    index: number;
  }[];
  columns: FieldArrayWithId<EquityBridgeFormValues, 'columns', '_fieldId'>[];
  removeCommonDebtItem: (itemId: string) => () => void;
  addCommonDebtItem: () => void;
};

const EquityBridgeCommonNetDebtItems = ({
  commonNetDebtItems,
  columns,
  removeCommonDebtItem,
  addCommonDebtItem,
}: EquityBridgeCommonNetDebtItemsProps) => (
  <>
    <tr>
      <td className="table-primary__cell--vertical-separator">{`${l('_Add')}:`}</td>
      {columns.map((column) => (
        <td key={column.columnId} />
      ))}
      <td />
    </tr>
    {commonNetDebtItems.map(({ item, index: itemIndex }) => (
      <tr key={item.netDebtItemId}>
        <td className="table-primary__cell--vertical-separator table-primary__cell--indentation">
          <GridTextField
            name={`netDebtItems.${itemIndex}.narrative`}
            isInputMasked={false}
            rules={{ ...getRequiredValidator() }}
            placeholder={l('_AddNarrative')}
          />
        </td>
        {columns.map((column, columnIndex) => (
          <td key={column.columnId}>
            <GridTextField
              name={`columns.${columnIndex}.netDebtValues.${item.netDebtItemId}`}
              fieldValueMask={numberPattern}
              valueAsNumber
              placeholder="0"
              alignment={Alignment.Right}
            />
          </td>
        ))}
        <td className="table-primary__cell--actions">
          <Button
            appearance={ButtonAppearance.CLEAN}
            size={ButtonSize.TABLE_ACTION}
            title={l('_DeleteItem')}
            onClick={removeCommonDebtItem(item.netDebtItemId)}>
            <MinusRoundedSvg />
          </Button>
        </td>
      </tr>
    ))}
    <tr>
      <td className="table-primary__cell--actions table-primary__cell--vertical-separator">
        <Button
          appearance={ButtonAppearance.DEFAULT_TERTIARY}
          size={ButtonSize.TABLE_ACTION}
          startIcon={<PlusSvg />}
          onClick={addCommonDebtItem}>
          {l('_AddDebtItem')}
        </Button>
      </td>
      {columns.map((column) => (
        <td key={column.columnId} />
      ))}
      <td />
    </tr>
  </>
);

export default EquityBridgeCommonNetDebtItems;
